var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "m-0",
      attrs: { "aria-label": _vm.$t("common.pageNavigation") }
    },
    [
      _c(
        "ul",
        { staticClass: "pagination m-0" },
        [
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: !_vm.hasPrevious },
              attrs: { title: _vm.$t("common.toPreviousPage") },
              on: { click: _vm.toPrevious }
            },
            [_vm._m(0)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: _vm.getClassActive(1),
              attrs: { title: _vm.$t("common.toFirstPage") },
              on: { click: _vm.toFirst }
            },
            [
              _c(
                "a",
                { staticClass: "page-link", attrs: { href: "javascript://" } },
                [_vm._v("1")]
              )
            ]
          ),
          _vm._v(" "),
          _vm.showLeftDelimiter
            ? _c("li", { staticClass: "page-item disabled" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.pagesNumbers, function(page) {
            return _c(
              "li",
              {
                staticClass: "page-item",
                class: _vm.getClassActive(page),
                on: {
                  click: function($event) {
                    return _vm.toNumber(page)
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "page-link",
                    attrs: { href: "javascript://" }
                  },
                  [_vm._v(_vm._s(page))]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.showRightDelimiter
            ? _c("li", { staticClass: "page-item disabled" }, [_vm._m(2)])
            : _vm._e(),
          _vm._v(" "),
          _vm.pagesCount > 1
            ? _c(
                "li",
                {
                  staticClass: "page-item",
                  class: _vm.getClassActive(_vm.pagesCount),
                  attrs: { title: _vm.$t("common.toLastPage") },
                  on: { click: _vm.toLast }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      attrs: { href: "javascript://" }
                    },
                    [_vm._v(_vm._s(_vm.pagesCount))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: !_vm.hasNext },
              attrs: { title: _vm.$t("common.toNextPage") },
              on: { click: _vm.toNext }
            },
            [_vm._m(3)]
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "page-link", attrs: { href: "javascript://" } },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("«")])]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "page-link", attrs: { href: "javascript://" } },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("...")])]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "page-link", attrs: { href: "javascript://" } },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("...")])]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "page-link", attrs: { href: "javascript://" } },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("»")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }